export var IDebugLog = {
  MapInitStart: "mapInitStart",
  LayerInitStart: "layerInitStart",
  LayerInitEnd: "layerInitEnd",
  SourceInitStart: "sourceInitStart",
  SourceInitEnd: "sourceInitEnd",
  ScaleInitStart: "scaleInitStart",
  ScaleInitEnd: "scaleInitEnd",
  MappingStart: "mappingStart",
  MappingEnd: "mappingEnd",
  BuildModelStart: "buildModelStart",
  BuildModelEnd: "buildModelEnd"
};